import React from 'react';
import { observer, inject } from 'mobx-react';
import {
  withStyles,
  Grid,
  DialogActions,
  Dialog,
  Button,
  DialogContent,
  DialogTitle,
  TextField,
  Paper,
  Select,
  MenuItem,
  FormHelperText,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Checkbox,
} from '@material-ui/core';
import 'react-datepicker/dist/react-datepicker.css';
import { withTranslation } from 'react-i18next';
import FormInputLabel from '../../components/FormInputLabelView';
import './styles/dialog.css';
import './styles/devicesview.css';
import Swal from 'sweetalert2';
import { clearLocalStorage } from '../../utils/common';
import { tenantInfo } from '../../utils/tenantInformation';

export class ManageDevice extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectSubGroups: [],
      data: this.props.deviceData,
      checked: false,
      errorField: {
        tenantId: false,
        name: false,
        deviceType: false,
      },
    };
  }

  handleToggle(val) {
    let selectSubGroups = this.state.selectSubGroups;
    const checkSelected = selectSubGroups.find((data) => data.id === val.id);

    if (checkSelected) {
      selectSubGroups = selectSubGroups.filter((data) => data.id !== val.id);
    } else {
      selectSubGroups.push(val);
    }
    this.setState({ selectSubGroups });
  }

  handleChange = async (e) => {
    let { name, value } = e.target;
    this.clearErrorField(name);
    this.setState((prevState) => {
      prevState.data[name] = value;
      return prevState;
    });

    if (name === 'tenantId') {
      this.setState({ selectSubGroups: [] });
      await this.props.subGroup.getBasicSubgroupInfoByTenantId(value);
    }
  };

  handleSubmit = async () => {
    const { t } = this.props;
    const { data, selectSubGroups } = this.state;

    if (this.validate()) {
      try {
        const subgroupIds = selectSubGroups.map((val) => val.id);
        const result = await this.props.device.updateDevice(data, subgroupIds);
        if (result.statusCode === 200) {
          Swal.fire({
            html: `<h4>${t('update_success')}`,
            type: 'success',
            customClass: { container: 'my-swal' },
          }).then(async (resultSuccess) => {
            if (resultSuccess.value) {
              await this.props.device.getDevices();
              this.props.handleCloseDialog();
            }
          });
        }
      } catch (e) {
        if (e.statusCode === 401) {
          clearLocalStorage();
          window.location.href = '/login';
        } else if (e.statusCode === 400) {
          const msg = e.error.message || `${t('failed_to_update')}`;
          Swal.fire({
            html: `<h4>${msg}`,
            type: 'error',
            customClass: { container: 'my-swal' },
          });
        } else {
          Swal.fire({
            html: `<h4>${t('failed_to_update')}`,
            type: 'error',
            customClass: { container: 'my-swal' },
          });
        }
      }
    }
  };

  validate() {
    const { data } = this.state;
    let checkName = !data.name ? true : false;
    let checkDeviceType = !data.deviceType || data.deviceType === 'NEW' ? true : false;

    this.setState({
      errorField: {
        name: checkName,
        deviceType: checkDeviceType,
      },
    });
    return !(checkName || checkDeviceType);
  }

  clearErrorField(key) {
    if (key === 'name') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          name: false,
        },
      });
    }
    if (key === 'deviceType') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          deviceType: false,
        },
      });
    }
  }

  render() {
    const { open, t, classes, handleCloseDialog, deviceData, disabledField } = this.props;
    const { deviceTypes } = this.props.deviceType.toJS();
    const tenants = tenantInfo();

    let { subGroupsInfo } = this.props.subGroup.toJS();
    subGroupsInfo = (subGroupsInfo || []).map((val) => {
      return {
        id: val.id,
        label: val.name,
      };
    });

    return (
      <Dialog open={open} onClose={handleCloseDialog} maxWidth='sm' fullWidth>
        <DialogTitle className='header' onClose={handleCloseDialog} id='form-dialog-title'>
          {t('select_module_for')} : &nbsp;
          <span className='headerMain'>{deviceData.deviceId}</span>
        </DialogTitle>

        <DialogContent>
          <Grid container spacing={16}>
            <Grid item xs={12} sm={4}>
              <FormInputLabel label={t('tenant')} required />
            </Grid>
            <Grid item xs={12} sm={8}>
              <Paper className={`${classes.root} selectInput`}>
                <Select
                  value={this.state.data.tenantId}
                  onChange={this.handleChange}
                  className={classes.underline}
                  inputProps={{
                    name: 'tenantId',
                    id: 'tenantId',
                  }}
                  disabled={disabledField}
                >
                  {(tenants || []).map((val) => (
                    <MenuItem fullwidth='true' key={val.id} value={val.id}>
                      {`${val.name || 'tenants'}`}
                    </MenuItem>
                  ))}
                </Select>
              </Paper>
              <FormHelperText
                error
                hidden={!this.state.data.reset ? !this.state.errorField.tenantId : true}
                id='component-error-text'
              >
                {t('required_field')}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={4}>
              <FormInputLabel label={t('device_type')} required />
            </Grid>
            <Grid item xs={12} sm={8}>
              <Paper className={`${classes.root} selectInput`}>
                <Select
                  value={this.state.data.deviceType}
                  onChange={this.handleChange}
                  className={classes.underline}
                  inputProps={{
                    name: 'deviceType',
                    id: 'deviceType',
                  }}
                  disabled={disabledField}
                >
                  {(deviceTypes.data || []).map((val) => (
                    <MenuItem fullwidth='true' key={val.id} value={val.id}>
                      {`${val.name || 'deviceType'}`}
                    </MenuItem>
                  ))}
                </Select>
              </Paper>
              <FormHelperText
                error
                hidden={!this.state.data.reset ? !this.state.errorField.deviceType : true}
                id='component-error-text'
              >
                {t('required_field')}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={4}>
              <FormInputLabel label={t('name')} required />
            </Grid>
            <Grid item xs={12} sm={8}>
              <TextField
                required
                id='name'
                name='name'
                fullWidth
                value={this.state.data.name}
                onChange={this.handleChange}
                inputProps={{ maxLength: 255 }}
                variant='outlined'
                margin='dense'
                error={!this.state.data.reset ? this.state.errorField.name : false}
                disabled={disabledField}
              />
              <FormHelperText
                error
                hidden={!this.state.data.reset ? !this.state.errorField.name : true}
                id='component-error-text'
              >
                {t('required_field')}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={12}>
              <FormInputLabel label={t('select_module')} />
              <List className={subGroupsInfo.length > 0 ? classes.muitiSelect : classes.muitiSelectNoBorder}>
                {subGroupsInfo.map((val) => {
                  return (
                    <ListItem key={val.id} role={undefined} dense button onClick={() => this.handleToggle(val)}>
                      <ListItemIcon style={{ marginRight: '0px' }}>
                        <Checkbox
                          style={{ padding: '0px' }}
                          color='primary'
                          edge='start'
                          checked={this.state.selectSubGroups.find((data) => data.id === val.id) ? true : false}
                          tabIndex={-1}
                          disableRipple
                          inputProps={{
                            'aria-labelledby': `checkbox-list-label-${val.id}`,
                          }}
                        />
                      </ListItemIcon>
                      <ListItemText
                        className={classes.labelCheckBox}
                        id={`checkbox-list-label-${val.id}`}
                        primary={`${val.label}`}
                      />
                    </ListItem>
                  );
                })}
              </List>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCloseDialog} color='default' id='cancel'>
            {t('cancel')}
          </Button>
          <Button onClick={this.handleSubmit} color='primary' id='save'>
            {t('save')}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const styles = (theme) => ({
  root: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
  },

  muitiSelect: {
    marginTop: '10px',
    borderRadius: '5px',
    borderStyle: 'solid',
    borderColor: 'gray',
    borderWidth: '1px',
    height: 200,
    position: 'relative',
    overflow: 'auto',
  },

  muitiSelectNoBorder: {
    marginTop: '35px',
    marginBottom: '35px',
  },

  underline: {
    backgroundColor: 'transparent',
    '&:hover:not($disabled):before,&:before': {
      borderBottom: 'none !important',
    },
    '&&&:before': {
      borderBottom: 'none',
      '&:focus': {
        backgroundColor: 'transparent',
      },
    },
    '&&:after': {
      borderBottom: 'none',
    },
  },

  labelCheckBox: {
    paddingLeft: '5px',
    fontSize: '16px',
    [theme.breakpoints.down('sm')]: {
      overflow: 'hidden',
      padding: '0',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      WebkitLineClamp: '1',
      WebkitBoxOrient: 'vertical',
    },
  },
});

export const page = inject('device', 'deviceType', 'subGroup')(observer(ManageDevice));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
